import React from 'react'

import Container from 'react-bootstrap/Container'
import Col from 'react-bootstrap/Col'
import Row from 'react-bootstrap/Row'
import Button from 'react-bootstrap/Button'
import Modal from 'react-bootstrap/Modal'

import CustomTable from '../../CustomTable/CustomTable.js'
import FormWerbemittel from './FormWerbemittel'
import BaseViewWerbemittel from './BaseViewWerbemittel'

import {connect} from 'react-redux'
import {setPrintTrigger} from '../../actions'

import BackendService from '../../BackendService'

import _ from 'lodash';

class ViewWerbemittelBestand extends BaseViewWerbemittel {

  render() {
    return (
      <div className={this.props.className}>
        <Container fluid>
          <Row style={{margin: "5px 0"}}>
            <Col xs="auto">
              <Button onClick={this.handleNew}>Neuer Eintrag</Button>
            </Col>
            <Col xs="auto">
              <Button 
                onClick={this.handleCopy} 
                disabled={this.state.selected.id == 0}>
                  Eintrag kopieren
              </Button>
            </Col>
          </Row>
          <Row className="max-height-wrapper-2">
            <Col xs={8} className="customRow">
              <CustomTable
                initialSortKey={'artikel'}
                ref={this.table}
                collumns={[
                  {
                    title: 'Bild',
                    key: 'previews',
                    cell: row => {
                      let images = this.state.selectingFromBestand
                        ? this.state.bestandImages[row.key]
                        : this.state.images[row.key]
                      if (images !== undefined && images) {
                        let src = _.find(
                          row.previews,
                          function(preview){
                            return preview.mainImage
                           },
                        )
                        if (src && src.id) {
                          let srcID = src.id
                          return (
                            <div
                              key={row.id + '_preview'}
                              style={{
                                alignItems: 'center',
                                display: 'flex',
                                justifyContent: 'center',
                                overflow: 'hidden',
                              }}
                            >
                              <img
                                src={images[srcID]}
                                alt=""
                                style={{maxHeight: '100px', maxWidth: '100px'}}
                              />
                            </div>
                          )
                        }
                      }
                    },
                  },
                  {
                    title: 'Artikel',
                    key: 'artikel',
                  },
                  {
                    title: 'Artikelausführung (Material, Besonderheit)',
                    key: 'ausfuerung',
                  },
                  {
                    title: 'Größe',
                    key: 'groesse',
                  },
                  {
                    title: 'Logo',
                    key: 'logo',
                  },
                  {
                    title: 'Lagerort',
                    key: 'lagerort',
                  },
                ]}
                data={this.state.data}
                onSelect={row => {
                  this.setState({selected: row})
                }}
              />
            </Col>
            <Col xs={4} className="customRow">
              <FormWerbemittel
                va={this.props.id}
                disabled={this.state.selected.id === 0}
                selected={this.state.selected}
                refresh={this.refresh}
                handleDelete={this.handleDelete}
                handleEdit={this.handleEdit}
                bestand
              />
            </Col>
          </Row>
          <Modal
            show={this.state.printing === true}
            centered
            onHide={() => this.setState({printing: false})}
          >
            <Modal.Header closeButton>
              <Modal.Title>Drucken/PDF erstellen</Modal.Title>
            </Modal.Header>
            <Modal.Body>
              {this.state.printing && (
                <span>PDF der Werbemittel wird erstellt...</span>
              )}
            </Modal.Body>
          </Modal>
        </Container>
      </div>
    )
  }

  print() {
    if (this.state.printing !== true) {
      let sortData = {
        sort: {
          [this.table.current.state.sortedCollumn]:
            this.table.current.state.sortDirection,
        },
      }
      this.props.dispatch(setPrintTrigger(false))
      this.setState({
        printing: true,
      })
      BackendService.printWerbemittel(0, sortData).then(response => {
        this.setState({
          printing: false,
        })
      })
    }
  }

  componentDidUpdate(prevProps) {
    if (this.props.triggerPrint !== prevProps.triggerPrint) {
      this.print()
    }
  }
}

const mapStateToProps = state => {
  return {
    triggerPrint: state.navigation.printView,
  }
}

export default connect(mapStateToProps)(ViewWerbemittelBestand)
